import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, map, of } from "rxjs";
import { IDevelopmentProject } from "../interfaces/development-project.interface";
import { DEV_PROJECTS } from "../data/development-info";
import { DOMAIN } from "../constants";

@Injectable({
    providedIn: 'root',
})
export class DevelopmentProjectsService {
    private baseUrl = `${DOMAIN}wp-json/wp/v2/case-studies?services_provided=49&per_page=30&page=1`;

    private projects = DEV_PROJECTS;

    constructor(private http: HttpClient) { }

    getProjects(): Observable<IDevelopmentProject[]> {
        return of(this.projects);
    }

    getProjectsFromWP(): Observable<IDevelopmentProject[]> {
        return this.http.get<any[]>(this.baseUrl).pipe(
            map(posts => posts.map(post => this.mapToProject(post)))
        );
    }

    getProjectByName(name: string): Observable<IDevelopmentProject | undefined> {
        return of(this.projects.find(
            project => project.name.toLowerCase() === name.toLowerCase()
        ));
    }

    getProjectByUri(uri: string): Observable<IDevelopmentProject | undefined> {
        return of(this.projects.find(
            project => project.redirectUrl.toLowerCase() === uri.toLowerCase()
        ));
    }

    getProjectIds(): string[] {
        return this.projects.map((p) => p.redirectUrl);
    }



    private mapToProject(post: any): IDevelopmentProject {
        const images: string[] = [];
        if (post._links?.['wp:attachment']?.length) {
            const attachmentUrl = post._links['wp:attachment'][0].href;
            images.push(attachmentUrl);
        }
        const description = post.acf?.description || post.yoast_head_json?.description || '';

        const logo = images[0] || `${DOMAIN}wp-content/uploads/2023/11/icon-4-300x300.png`;

        return {
            name: post.title?.rendered || 'No title',
            description,
            logo,
            images,
            redirectUrl: post.link
        };
    }

}
